import React from 'react';

import {
  GENDER_OPTIONS_STRICT,
  EMOTION_OPTIONS_STRICT,
  MASK_OPTIONS_STRICT,
  AGE_OPTIONS,
  TEMPERATURE_BY_GROUP_OPTIONS,
} from '@vlabs/api-bindings/src/constants';
import SelectOptionGroupLabel from '@vlabs/shared/legacy-components/select-option-group-label/SelectOptionGroupLabel';
import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { selectSourceOptionsByAccount } from '@vlabs/pages/sources/selectors';

import st from './SharedFormStyles.module.sass';

function EventRulesNotificationSubFormComponent({ camOptions = [] }) {
  const { t } = useTranslation();
  const {
    control,
    register,
    watch,
    formState: { errors },
    versionMoreThan0_1_6,
    listOptions,
    handlerOptions,
  } = useFormContext();

  const temperatureSimilarityGte = watch('filters.temperature__gte') || 0;
  const topSimilarObjectSimilarityGte = watch('filters.top_similar_object_similarity__gte');

  return (
    <div className={st.NotificationFormBlock}>
      <h6>{t('vlNotifier:rules')}</h6>

      <div>
        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('handler')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            isClearable
            isMulti
            name="filters.handlers"
            options={handlerOptions}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('list')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            isClearable
            isMulti
            name="filters.lists"
            options={listOptions}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:filters.top_similar_object_similarity')}
          titleClassName={st.Title}
        >
          <div className={st.InputsContainer}>
            <Control.Input
              placeholder={t('vlNotifier:filters.top_similar_object_similarity__gte')}
              {...register('filters.top_similar_object_similarity__gte', {
                min: validate.gte(0),
                max: validate.lte(1),
                validate: validate.number(),
              })}
              errors={errors}
            />
            <span>:</span>
            <Control.Input
              placeholder={t('vlNotifier:filters.top_similar_object_similarity__lt')}
              {...register('filters.top_similar_object_similarity__lt', {
                min: validate.gte(Math.max(topSimilarObjectSimilarityGte, 0)),
                max: validate.lte(1),
                validate: validate.number(),
              })}
              errors={errors}
            />
          </div>
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:filters.gender')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            isClearable
            name="filters.gender"
            options={GENDER_OPTIONS_STRICT.raw}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:targets.source')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            formatGroupLabel={SelectOptionGroupLabel}
            isCreatable
            isMulti
            name="filters.sources"
            options={camOptions}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:filters.age')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            isClearable
            name="filters.age"
            options={AGE_OPTIONS.raw}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:filters.emotion')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            isMulti
            name="filters.emotions"
            options={EMOTION_OPTIONS_STRICT.raw}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:filters.mask')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            isMulti
            name="filters.masks"
            options={MASK_OPTIONS_STRICT.raw}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:filters.tags')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            disabled={!versionMoreThan0_1_6}
            formatGroupLabel={SelectOptionGroupLabel}
            isClearable
            isCreatable
            isMulti
            name="filters.tags"
            options={TEMPERATURE_BY_GROUP_OPTIONS.raw}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          disabled={!versionMoreThan0_1_6}
          title={t('vlNotifier:filters.temperature')}
          titleClassName={st.Title}
        >
          <div className={st.InputsContainer}>
            <Control.Input
              placeholder={t('vlNotifier:filters.temperature__gte')}
              {...register('filters.temperature__gte', {
                min: validate.gte(35),
                max: validate.lte(45),
                validate: validate.number(),
              })}
              errors={errors}
            />
            <span>:</span>
            <Control.Input
              placeholder={t('vlNotifier:filters.temperature__lt')}
              {...register('filters.temperature__lt', {
                min: validate.gte(Math.max(temperatureSimilarityGte, 35)),
                max: validate.lte(45),
                validate: validate.number(),
              })}
              errors={errors}
            />
          </div>
        </SettingsItemWrapper>
      </div>
    </div>
  );
}

export const EventRulesNotificationSubForm = connect((state) => ({
  camOptions: selectSourceOptionsByAccount(state),
}), null)(EventRulesNotificationSubFormComponent);

EventRulesNotificationSubForm.propTypes = {
  camOptions: PropTypes.arrayOf(PropTypes.object),
};
